import { defineComponent as De, inject as ze, ref as Te, computed as _e, watchEffect as He, onUnmounted as Ue, h as o, Fragment as je } from "vue";
import { cssrAnchorMetaName as Be } from "./ghl-ui.es1321.js";
import { c as me } from "./ghl-ui.es669.js";
import { dataTableInjectionKey as Ve } from "./ghl-ui.es992.js";
import { createRowClassName as We, getColKey as qe, isColumnSorting as Xe } from "./ghl-ui.es996.js";
import Ge from "./ghl-ui.es1489.js";
import Ae from "./ghl-ui.es1490.js";
import Je from "./ghl-ui.es1491.js";
import Qe from "./ghl-ui.es1492.js";
import Ye from "./ghl-ui.es1345.js";
import Ke from "./ghl-ui.es735.js";
import { formatLength as Ze } from "./ghl-ui.es1026.js";
import Ie from "./ghl-ui.es1029.js";
import { pxfy as Le } from "./ghl-ui.es902.js";
import et from "./ghl-ui.es210.js";
import tt from "./ghl-ui.es780.js";
import { warn as Oe } from "./ghl-ui.es899.js";
import { repeat as at } from "./ghl-ui.es974.js";
import { resolveSlot as lt } from "./ghl-ui.es906.js";
import nt from "./ghl-ui.es1043.js";
function ot(v, b) {
  const l = [];
  function c(m, u) {
    m.forEach((x) => {
      x.children && b.has(x.key) ? (l.push({
        tmNode: x,
        striped: !1,
        key: x.key,
        index: u
      }), c(x.children, u)) : l.push({
        key: x.key,
        tmNode: x,
        striped: !1,
        index: u
      });
    });
  }
  return v.forEach((m) => {
    l.push(m);
    const {
      children: u
    } = m.tmNode;
    u && b.has(m.key) && c(u, m.index);
  }), l;
}
const rt = De({
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    cols: {
      type: Array,
      required: !0
    },
    onMouseenter: Function,
    onMouseleave: Function
  },
  render() {
    const {
      clsPrefix: v,
      id: b,
      cols: l,
      onMouseenter: c,
      onMouseleave: m
    } = this;
    return o("table", {
      style: {
        tableLayout: "fixed"
      },
      class: `${v}-data-table-table`,
      onMouseenter: c,
      onMouseleave: m
    }, o("colgroup", null, l.map((u) => o("col", {
      key: u.key,
      style: u.style
    }))), o("tbody", {
      "data-n-id": b,
      class: `${v}-data-table-tbody`
    }, this.$slots));
  }
}), Et = De({
  name: "DataTableBody",
  props: {
    onResize: Function,
    showHeader: Boolean,
    flexHeight: Boolean,
    bodyStyle: Object
  },
  setup(v) {
    const {
      slots: b,
      bodyWidthRef: l,
      mergedExpandedRowKeysRef: c,
      mergedClsPrefixRef: m,
      mergedThemeRef: u,
      scrollXRef: x,
      colsRef: ye,
      paginatedDataRef: P,
      rawPaginatedDataRef: pe,
      fixedColumnLeftMapRef: Z,
      fixedColumnRightMapRef: I,
      mergedCurrentPageRef: he,
      rowClassNameRef: W,
      leftActiveFixedColKeyRef: ee,
      leftActiveFixedChildrenColKeysRef: g,
      rightActiveFixedColKeyRef: q,
      rightActiveFixedChildrenColKeysRef: O,
      renderExpandRef: ve,
      hoverKeyRef: te,
      summaryRef: be,
      mergedSortStateRef: xe,
      virtualScrollRef: D,
      componentId: $,
      mergedTableLayoutRef: ge,
      childTriggerColIndexRef: X,
      indentRef: ae,
      rowPropsRef: le,
      maxHeightRef: Re,
      stripedRef: ne,
      loadingRef: oe,
      onLoadRef: G,
      loadingKeySetRef: E,
      expandableRef: re,
      stickyExpandedRowsRef: Se,
      renderExpandIconRef: Ce,
      summaryPlacementRef: de,
      treeMateRef: se,
      scrollbarPropsRef: F,
      setHeaderScrollLeft: J,
      doUpdateExpandedRowKeys: N,
      handleTableBodyScroll: T,
      doCheck: Q,
      doUncheck: K,
      renderCell: ie
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = ze(Ve), L = Te(null), M = Te(null), ce = Te(null), z = Ke(() => P.value.length === 0), n = Ke(() => v.showHeader || !z.value), r = Ke(() => v.showHeader || z.value);
    let _ = "";
    const y = _e(() => new Set(c.value));
    function f(e) {
      var a;
      return (a = se.value.getNode(e)) === null || a === void 0 ? void 0 : a.rawNode;
    }
    function ke(e, a, d) {
      const t = f(e.key);
      if (!t) {
        Oe("data-table", `fail to get row data with key ${e.key}`);
        return;
      }
      if (d) {
        const s = P.value.findIndex((p) => p.key === _);
        if (s !== -1) {
          const p = P.value.findIndex((V) => V.key === e.key), B = Math.min(s, p), R = Math.max(s, p), w = [];
          P.value.slice(B, R + 1).forEach((V) => {
            V.disabled || w.push(V.key);
          }), a ? Q(w, !1, t) : K(w, t), _ = e.key;
          return;
        }
      }
      a ? Q(e.key, !1, t) : K(e.key, t), _ = e.key;
    }
    function we(e) {
      const a = f(e.key);
      if (!a) {
        Oe("data-table", `fail to get row data with key ${e.key}`);
        return;
      }
      Q(e.key, !0, a);
    }
    function C() {
      if (!n.value) {
        const {
          value: a
        } = ce;
        return a || null;
      }
      if (D.value)
        return ue();
      const {
        value: e
      } = L;
      return e ? e.containerRef : null;
    }
    function k(e, a) {
      var d;
      if (E.value.has(e))
        return;
      const {
        value: t
      } = c, s = t.indexOf(e), p = Array.from(t);
      ~s ? (p.splice(s, 1), N(p)) : a && !a.isLeaf && !a.shallowLoaded ? (E.value.add(e), (d = G.value) === null || d === void 0 || d.call(G, a.rawNode).then(() => {
        const {
          value: B
        } = c, R = Array.from(B);
        ~R.indexOf(e) || R.push(e), N(R);
      }).finally(() => {
        E.value.delete(e);
      })) : (p.push(e), N(p));
    }
    function Y() {
      te.value = null;
    }
    function ue() {
      const {
        value: e
      } = M;
      return (e == null ? void 0 : e.listElRef) || null;
    }
    function $e() {
      const {
        value: e
      } = M;
      return (e == null ? void 0 : e.itemsElRef) || null;
    }
    function Pe(e) {
      var a;
      T(e), (a = L.value) === null || a === void 0 || a.sync();
    }
    function H(e) {
      var a;
      const {
        onResize: d
      } = v;
      d && d(e), (a = L.value) === null || a === void 0 || a.sync();
    }
    const i = {
      getScrollContainer: C,
      scrollTo(e, a) {
        var d, t;
        D.value ? (d = M.value) === null || d === void 0 || d.scrollTo(e, a) : (t = L.value) === null || t === void 0 || t.scrollTo(e, a);
      }
    }, U = me([({
      props: e
    }) => {
      const a = (t) => t === null ? null : me(`[data-n-id="${e.componentId}"] [data-col-key="${t}"]::after`, {
        boxShadow: "var(--n-box-shadow-after)"
      }), d = (t) => t === null ? null : me(`[data-n-id="${e.componentId}"] [data-col-key="${t}"]::before`, {
        boxShadow: "var(--n-box-shadow-before)"
      });
      return me([a(e.leftActiveFixedColKey), d(e.rightActiveFixedColKey), e.leftActiveFixedChildrenColKeys.map((t) => a(t)), e.rightActiveFixedChildrenColKeys.map((t) => d(t))]);
    }]);
    let j = !1;
    return He(() => {
      const {
        value: e
      } = ee, {
        value: a
      } = g, {
        value: d
      } = q, {
        value: t
      } = O;
      if (!j && e === null && d === null)
        return;
      const s = {
        leftActiveFixedColKey: e,
        leftActiveFixedChildrenColKeys: a,
        rightActiveFixedColKey: d,
        rightActiveFixedChildrenColKeys: t,
        componentId: $
      };
      U.mount({
        id: `n-${$}`,
        force: !0,
        props: s,
        anchorMetaName: Be
      }), j = !0;
    }), Ue(() => {
      U.unmount({
        id: `n-${$}`
      });
    }), Object.assign({
      bodyWidth: l,
      summaryPlacement: de,
      dataTableSlots: b,
      componentId: $,
      scrollbarInstRef: L,
      virtualListRef: M,
      emptyElRef: ce,
      summary: be,
      mergedClsPrefix: m,
      mergedTheme: u,
      scrollX: x,
      cols: ye,
      loading: oe,
      bodyShowHeaderOnly: r,
      shouldDisplaySomeTablePart: n,
      empty: z,
      paginatedDataAndInfo: _e(() => {
        const {
          value: e
        } = ne;
        let a = !1;
        return {
          data: P.value.map(e ? (t, s) => (t.isLeaf || (a = !0), {
            tmNode: t,
            key: t.key,
            striped: s % 2 === 1,
            index: s
          }) : (t, s) => (t.isLeaf || (a = !0), {
            tmNode: t,
            key: t.key,
            striped: !1,
            index: s
          })),
          hasChildren: a
        };
      }),
      rawPaginatedData: pe,
      fixedColumnLeftMap: Z,
      fixedColumnRightMap: I,
      currentPage: he,
      rowClassName: W,
      renderExpand: ve,
      mergedExpandedRowKeySet: y,
      hoverKey: te,
      mergedSortState: xe,
      virtualScroll: D,
      mergedTableLayout: ge,
      childTriggerColIndex: X,
      indent: ae,
      rowProps: le,
      maxHeight: Re,
      loadingKeySet: E,
      expandable: re,
      stickyExpandedRows: Se,
      renderExpandIcon: Ce,
      scrollbarProps: F,
      setHeaderScrollLeft: J,
      handleVirtualListScroll: Pe,
      handleVirtualListResize: H,
      handleMouseleaveTable: Y,
      virtualListContainer: ue,
      virtualListContent: $e,
      handleTableBodyScroll: T,
      handleCheckboxUpdateChecked: ke,
      handleRadioUpdateChecked: we,
      handleUpdateExpanded: k,
      renderCell: ie
    }, i);
  },
  render() {
    const {
      mergedTheme: v,
      scrollX: b,
      mergedClsPrefix: l,
      virtualScroll: c,
      maxHeight: m,
      mergedTableLayout: u,
      flexHeight: x,
      loadingKeySet: ye,
      onResize: P,
      setHeaderScrollLeft: pe
    } = this, Z = b !== void 0 || m !== void 0 || x, I = !Z && u === "auto", he = b !== void 0 || I, W = {
      minWidth: Ze(b) || "100%"
    };
    b && (W.width = "100%");
    const ee = o(Ie, Object.assign({}, this.scrollbarProps, {
      ref: "scrollbarInstRef",
      scrollable: Z || I,
      class: `${l}-data-table-base-table-body`,
      style: this.empty ? void 0 : this.bodyStyle,
      theme: v.peers.Scrollbar,
      themeOverrides: v.peerOverrides.Scrollbar,
      contentStyle: W,
      container: c ? this.virtualListContainer : void 0,
      content: c ? this.virtualListContent : void 0,
      horizontalRailStyle: {
        zIndex: 3
      },
      verticalRailStyle: {
        zIndex: 3
      },
      xScrollable: he,
      onScroll: c ? void 0 : this.handleTableBodyScroll,
      internalOnUpdateScrollLeft: pe,
      onResize: P
    }), {
      default: () => {
        const g = {}, q = {}, {
          cols: O,
          paginatedDataAndInfo: ve,
          mergedTheme: te,
          fixedColumnLeftMap: be,
          fixedColumnRightMap: xe,
          currentPage: D,
          rowClassName: $,
          mergedSortState: ge,
          mergedExpandedRowKeySet: X,
          stickyExpandedRows: ae,
          componentId: le,
          childTriggerColIndex: Re,
          expandable: ne,
          rowProps: oe,
          handleMouseleaveTable: G,
          renderExpand: E,
          summary: re,
          handleCheckboxUpdateChecked: Se,
          handleRadioUpdateChecked: Ce,
          handleUpdateExpanded: de
        } = this, {
          length: se
        } = O;
        let F;
        const {
          data: J,
          hasChildren: N
        } = ve, T = N ? ot(J, X) : J;
        if (re) {
          const n = re(this.rawPaginatedData);
          if (Array.isArray(n)) {
            const r = n.map((_, y) => ({
              isSummaryRow: !0,
              key: `__n_summary__${y}`,
              tmNode: {
                rawNode: _,
                disabled: !0
              },
              index: -1
            }));
            F = this.summaryPlacement === "top" ? [...r, ...T] : [...T, ...r];
          } else {
            const r = {
              isSummaryRow: !0,
              key: "__n_summary__",
              tmNode: {
                rawNode: n,
                disabled: !0
              },
              index: -1
            };
            F = this.summaryPlacement === "top" ? [r, ...T] : [...T, r];
          }
        } else
          F = T;
        const Q = N ? {
          width: Le(this.indent)
        } : void 0, K = [];
        F.forEach((n) => {
          E && X.has(n.key) && (!ne || ne(n.tmNode.rawNode)) ? K.push(n, {
            isExpandedRow: !0,
            key: `${n.key}-expand`,
            // solve key repeat of the expanded row
            tmNode: n.tmNode,
            index: n.index
          }) : K.push(n);
        });
        const {
          length: ie
        } = K, L = {};
        J.forEach(({
          tmNode: n
        }, r) => {
          L[r] = n.key;
        });
        const M = ae ? this.bodyWidth : null, ce = M === null ? void 0 : `${M}px`, z = (n, r, _) => {
          const {
            index: y
          } = n;
          if ("isExpandedRow" in n) {
            const {
              tmNode: {
                key: H,
                rawNode: i
              }
            } = n;
            return o("tr", {
              class: `${l}-data-table-tr ${l}-data-table-tr--expanded`,
              key: `${H}__expand`
            }, o("td", {
              class: [`${l}-data-table-td`, `${l}-data-table-td--last-col`, r + 1 === ie && `${l}-data-table-td--last-row`],
              colspan: se
            }, ae ? o("div", {
              class: `${l}-data-table-expand`,
              style: {
                width: ce
              }
            }, E(i, y)) : E(i, y)));
          }
          const f = "isSummaryRow" in n, ke = !f && n.striped, {
            tmNode: we,
            key: C
          } = n, {
            rawNode: k
          } = we, Y = X.has(C), ue = oe ? oe(k, y) : void 0, $e = typeof $ == "string" ? $ : We(k, y, $);
          return o("tr", Object.assign({
            onMouseenter: () => {
              this.hoverKey = C;
            },
            key: C,
            class: [`${l}-data-table-tr`, f && `${l}-data-table-tr--summary`, ke && `${l}-data-table-tr--striped`, Y && `${l}-data-table-tr--expanded`, $e]
          }, ue), O.map((H, i) => {
            var U, j, e, a, d;
            if (r in g) {
              const h = g[r], S = h.indexOf(i);
              if (~S)
                return h.splice(S, 1), null;
            }
            const {
              column: t
            } = H, s = qe(H), {
              rowSpan: p,
              colSpan: B
            } = t, R = f ? ((U = n.tmNode.rawNode[s]) === null || U === void 0 ? void 0 : U.colSpan) || 1 : B ? B(k, y) : 1, w = f ? ((j = n.tmNode.rawNode[s]) === null || j === void 0 ? void 0 : j.rowSpan) || 1 : p ? p(k, y) : 1, V = i + R === se, Fe = r + w === ie, fe = w > 1;
            if (fe && (q[r] = {
              [i]: []
            }), R > 1 || fe)
              for (let h = r; h < r + w; ++h) {
                fe && q[r][i].push(L[h]);
                for (let S = i; S < i + R; ++S)
                  h === r && S === i || (h in g ? g[h].push(S) : g[h] = [S]);
              }
            const Ne = fe ? this.hoverKey : null, {
              cellProps: Ee
            } = t, A = Ee == null ? void 0 : Ee(k, y), Me = {
              "--indent-offset": ""
            };
            return o("td", Object.assign({}, A, {
              key: s,
              style: [{
                textAlign: t.align || void 0,
                left: Le((e = be[s]) === null || e === void 0 ? void 0 : e.start),
                right: Le((a = xe[s]) === null || a === void 0 ? void 0 : a.start)
              }, Me, (A == null ? void 0 : A.style) || ""],
              colspan: R,
              rowspan: _ ? void 0 : w,
              "data-col-key": s,
              class: [`${l}-data-table-td`, t.className, A == null ? void 0 : A.class, f && `${l}-data-table-td--summary`, (Ne !== null && q[r][i].includes(Ne) || Xe(t, ge)) && `${l}-data-table-td--hover`, t.fixed && `${l}-data-table-td--fixed-${t.fixed}`, t.align && `${l}-data-table-td--${t.align}-align`, t.type === "selection" && `${l}-data-table-td--selection`, t.type === "expand" && `${l}-data-table-td--expand`, V && `${l}-data-table-td--last-col`, Fe && `${l}-data-table-td--last-row`]
            }), N && i === Re ? [at(Me["--indent-offset"] = f ? 0 : n.tmNode.level, o("div", {
              class: `${l}-data-table-indent`,
              style: Q
            })), f || n.tmNode.isLeaf ? o("div", {
              class: `${l}-data-table-expand-placeholder`
            }) : o(Ae, {
              class: `${l}-data-table-expand-trigger`,
              clsPrefix: l,
              expanded: Y,
              renderExpandIcon: this.renderExpandIcon,
              loading: ye.has(n.key),
              onClick: () => {
                de(C, n.tmNode);
              }
            })] : null, t.type === "selection" ? f ? null : t.multiple === !1 ? o(Qe, {
              key: D,
              rowKey: C,
              disabled: n.tmNode.disabled,
              onUpdateChecked: () => {
                Ce(n.tmNode);
              }
            }) : o(Je, {
              key: D,
              rowKey: C,
              disabled: n.tmNode.disabled,
              onUpdateChecked: (h, S) => {
                Se(n.tmNode, h, S.shiftKey);
              }
            }) : t.type === "expand" ? f ? null : !t.expandable || !((d = t.expandable) === null || d === void 0) && d.call(t, k) ? o(Ae, {
              clsPrefix: l,
              expanded: Y,
              renderExpandIcon: this.renderExpandIcon,
              onClick: () => {
                de(C, null);
              }
            }) : null : o(Ge, {
              clsPrefix: l,
              index: y,
              row: k,
              column: t,
              isSummary: f,
              mergedTheme: te,
              renderCell: this.renderCell
            }));
          }));
        };
        return c ? o(et, {
          ref: "virtualListRef",
          items: K,
          itemSize: 28,
          visibleItemsTag: rt,
          visibleItemsProps: {
            clsPrefix: l,
            id: le,
            cols: O,
            onMouseleave: G
          },
          showScrollbar: !1,
          onResize: this.handleVirtualListResize,
          onScroll: this.handleVirtualListScroll,
          itemsStyle: W,
          itemResizable: !0
        }, {
          default: ({
            item: n,
            index: r
          }) => z(n, r, !0)
        }) : o("table", {
          class: `${l}-data-table-table`,
          onMouseleave: G,
          style: {
            tableLayout: this.mergedTableLayout
          }
        }, o("colgroup", null, O.map((n) => o("col", {
          key: n.key,
          style: n.style
        }))), this.showHeader ? o(Ye, {
          discrete: !1
        }) : null, this.empty ? null : o("tbody", {
          "data-n-id": le,
          class: `${l}-data-table-tbody`
        }, K.map((n, r) => z(n, r, !1))));
      }
    });
    if (this.empty) {
      const g = () => o("div", {
        class: [`${l}-data-table-empty`, this.loading && `${l}-data-table-empty--hide`],
        style: this.bodyStyle,
        ref: "emptyElRef"
      }, lt(this.dataTableSlots.empty, () => [o(nt, {
        theme: this.mergedTheme.peers.Empty,
        themeOverrides: this.mergedTheme.peerOverrides.Empty
      })]));
      return this.shouldDisplaySomeTablePart ? o(je, null, ee, g()) : o(tt, {
        onResize: this.onResize
      }, {
        default: g
      });
    }
    return ee;
  }
});
export {
  Et as default
};
